import * as React from "react";
import { Button, Popover, Spinner } from "@/components/ui";

export interface FiltersPopoverLayoutProps {
  children: React.ReactNode;
  onClear?: () => void;
  onDone: () => void;
  side?: "right" | "bottom";
  align?: "start" | "center" | "end";
  sideOffset?: number;
  initialFocus?: boolean;
  /** "124 reviews"; null shows a spinner while the count loads; undefined shows nothing. */
  resultLabel?: string | null;
}

/** Shared chrome for filter popovers: a scrolling body of sections, then the count, Clear All, and Done. */
export function FiltersPopoverLayout({
  children,
  onClear,
  onDone,
  side = "right",
  align = "end",
  sideOffset = 8,
  initialFocus,
  resultLabel,
}: FiltersPopoverLayoutProps) {
  return (
    <Popover.Content
      className="w-[380px] max-w-[calc(100vw-2rem)] shadow-xl border border-slate-100 bg-white rounded-xl focus:outline-hidden overflow-hidden"
      align={align}
      side={side}
      sideOffset={sideOffset}
      initialFocus={initialFocus}
    >
      <div className="flex min-w-0 flex-col gap-4 overflow-hidden">
        <div className="grid min-w-0 gap-4 overflow-x-hidden overflow-y-auto p-1 max-h-[600px] no-scrollbar [&>*]:min-w-0">
          {children}
        </div>

        <div className="flex justify-end items-center shrink-0 gap-2">
          {typeof resultLabel === "string" ? (
            <span className="text-xs text-muted-foreground mr-auto">{resultLabel}</span>
          ) : resultLabel === null ? (
            <Spinner className="size-3.5 text-muted-foreground/70 mr-auto" />
          ) : null}
          {onClear ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClear}
              className="text-slate-500 hover:text-slate-800 h-8 text-xs"
            >
              Clear All
            </Button>
          ) : null}
          <Button size="sm" onClick={onDone} className="h-8 text-xs">
            Done
          </Button>
        </div>
      </div>
    </Popover.Content>
  );
}
